"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIssuesReferencePickerTableColumns = void 0;
var _useTableColumnDefs = require("../IssuesTab/IssueLog/IssueTable/useTableColumnDefs");
var _react = require("react");
var _columnKeys = require("../IssuesTab/IssueLog/IssueTable/columnKeys");
const useIssuesReferencePickerTableColumns = () => {
  const getStandardFieldColumnDef = (0, _useTableColumnDefs.useGetStandardFieldColumnDef)();
  return (0, _react.useMemo)(() => [_columnKeys.ISSUE_COLUMN_KEYS.ID, _columnKeys.ISSUE_COLUMN_KEYS.TITLE, _columnKeys.ISSUE_COLUMN_KEYS.STATUS, _columnKeys.ISSUE_COLUMN_KEYS.ISSUE_TYPE,
  //TODO: ISSUE_COLUMN_KEYS.STAMP,
  _columnKeys.ISSUE_COLUMN_KEYS.ASSIGNED_TO, _columnKeys.ISSUE_COLUMN_KEYS.DUE_DATE, _columnKeys.ISSUE_COLUMN_KEYS.PLACEMENT].map(getStandardFieldColumnDef), [getStandardFieldColumnDef]);
};
exports.useIssuesReferencePickerTableColumns = useIssuesReferencePickerTableColumns;
//# sourceMappingURL=usesIssuesReferencePickerTableColumns.js.map